<template lang="html">
  <tr :class="{ selected: isSelected, 'row-disabled': isRoleReadOrScoring }">
    <td class="column-checkbox" style="width: 40px; max-width: 40px">
      <vchecklabel v-model="isSelected" :disabled="isRoleReadOrScoring" />
    </td>

    <td class="column-name pointer" @click.self="gotoEditRoute">
      <router-link tag="a" :to="editRoute" :disabled="isRoleReadOrScoring" :title="model.title">
        {{ model.title }}
      </router-link>

      <span v-if="!model.active" class="archive-label">
        {{ $tr('vacancies.archiveLabel') }}
      </span>
    </td>

    <td class="column-numbers pointer" width="8.1%">
      <a class="vacancy-item-title" @click.prevent="applyFilter">
        <span :class="{ candidates__new: model.new_responses_count }">
          {{ model.new_responses_count }}
        </span>
        <span>/</span>
        <span>{{ model.sent_responses_count }}</span>
      </a>
    </td>

    <td class="column-landing">
      <a
        v-if="custom_link"
        v-tooltip="{
          content: custom_link_text,
          trigger: 'hover',
          placement: 'top'
        }"
        class="landing-link"
        :href="custom_link"
        target="_blank"
        rel="noopener"
      >
        {{ custom_link_text }}
      </a>
    </td>

    <td class="column-date pointer" @click.self="gotoEditRoute">
      {{ createdAt }}
    </td>

    <td class="column-creator pointer" @click.self="gotoEditRoute">
      {{ createdBy }}
    </td>

    <td class="column-modules">
      <div class="new_modules">
        <img
          v-tooltip="{
            content: $tr('common.list.landing'),
            placement: 'auto',
            classes: 'tight'
          }"
          class="stage-icon"
          src="/static/images/elements/stage_landing.svg"
          @click="go_to_landing"
        />

        <img
          v-if="is_active_application"
          v-tooltip="{
            content: $tr('vacancy.preferences.settings.application'),
            placement: 'auto',
            classes: 'tight'
          }"
          class="stage-icon"
          src="/static/images/elements/stage_survey.svg"
          @click="go_to_application"
        />

        <img
          v-if="is_active_test"
          v-tooltip="{
            content: $tr('vacancies.list.row.modules.module.tests.tooltip'),
            placement: 'auto',
            classes: 'tight'
          }"
          class="stage-icon"
          src="/static/images/elements/stage_test.svg"
          @click="go_to_tests"
        />

        <img
          v-if="is_active_video"
          v-tooltip="{
            content: $tr('vacancies.list.row.modules.module.video.tooltip'),
            placement: 'auto',
            classes: 'tight'
          }"
          class="stage-icon"
          src="/static/images/elements/stage_videointerview.svg"
          @click="go_to_videointerview"
        />
      </div>
    </td>
  </tr>
</template>

<script>
  import { get } from 'lodash';
  import Moment from 'moment';

  export default {
    name: 'VacanciesRow',
    props: {
      model: Object
    },

    computed: {
      ...mapGetters('vacancies', ['getIsSelectedVacancies']),
      is_active_test() {
        let module = this.model._embedded.modules.find(i => i.id_module === 'test');
        return module ? module.is_active : false;
      },

      is_active_video() {
        let module = this.model._embedded.modules.find(i => i.id_module === 'videointerview');
        return module ? module.is_active : false;
      },

      is_active_application() {
        let module = this.model._embedded.modules.find(i => i.id_module === 'survey');
        return module ? module.is_active : false;
      },

      domain() {
        return `${window.location.origin}/r/`;
      },

      custom_link() {
        if (!this.model) {
          return null;
        }
        return this.model.landing_url_path === null || this.model.landing_url_path === ''
          ? `${this.domain}${this.model.token}`
          : `${this.domain}${this.model.landing_url_path}`;
      },

      custom_link_text() {
        if (!this.custom_link) {
          return '';
        }
        return this.custom_link.replace('http://', '').replace('https://', '');
      },

      editRoute() {
        return {
          name: 'vacancy_basic',
          params: {
            id: this.model.id
          }
        };
      },

      isRoleReadOrScoring() {
        if (!this.model) {
          return false;
        }

        return this.model.role === 'role_read' || this.model.role === 'role_read_scoring';
      },

      isSelected: {
        get() {
          return this.getIsSelectedVacancies(this.model);
        },

        set(state) {
          this.setSelectedState({
            model: this.model,
            state
          });
        }
      },

      createdAt() {
        return this.model.date_created
          ? Moment(this.model.date_created).format(this.dateFormat)
          : null;
      },

      createdBy() {
        const { first_name, last_name } = get(this.model._embedded.user, 'userName', {
          first_name: '',
          last_name: ''
        });
        return !this.is_japan_locale
          ? [first_name, last_name].join(' ')
          : [last_name, first_name].join(' ');
      },

      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },

      dateFormat() {
        return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
      }
    },

    methods: {
      ...mapActions('vacancies', ['setSelectedState']),
      applyFilter() {
        this.$router.push({
          name: 'responses',
          query: {
            vacancy: {
              id: this.model.id,
              name: this.model.name
            }
          }
        });
      },

      gotoEditRoute() {
        if (this.isRoleReadOrScoring) {
          return false;
        }

        this.$router.push(this.editRoute);
      },

      go_to_landing() {
        this.$router.push({
          name: 'vacancy_landing',
          params: { id: this.model.id }
        });
      },

      go_to_videointerview() {
        this.$router.push({
          name: 'vacancy_video',
          params: { id: this.model.id }
        });
      },

      go_to_application() {
        this.$router.push({
          name: 'vacancy_application',
          params: { id: this.model.id }
        });
      },

      go_to_tests() {
        this.$router.push({
          name: 'vacancy_tests',
          params: { id: this.model.id }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

tr {
  height: 59px;
  box-sizing: border-box;

  &:hover,
  &.selected {
    background: rgba(170, 170, 170, 0.05);
  }

  &.row-disabled {
    cursor: not-allowed;
  }
}

.landing-link {
  color: $green;
  overflow: hidden;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  display: block;
}

.candidates__new {
  color: $green;
}

.column-numbers {
  font-size: 1.2em;
}

.column-name-block {
  position: relative;
}

tr.archive .column-name a {
  display: inline-flex;
}

.column-name {
  font-size: 1.2em;
  height: 59px;

  a {
    display: block;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

  .vacancy-item-links-wrap {
    margin-left: auto;
  }
}
.new_modules {
  display: flex;

  .stage-icon {
    display: block;
    margin-right: 8px;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}

.pointer {
  cursor: pointer;
}
</style>
